export default __webpack_public_path__ + "static/media/not_supported_icon.667f2ad2.svg";